import { createAction } from '@reduxjs/toolkit'
import { DetailedRefundAmountRequest } from '../api/refund'

export const submitDetailedRefund = createAction<DetailedRefundAmountRequest>('REFUNDS_SUBMIT_DETAILED')